import React from 'react';
import PropTypes from 'prop-types';
import { isEqual, union, uniqueId } from 'lodash';
import MapContext from '../MapContext';
import { toFeatures } from '../../../lib/map_helpers';

export default class GeoJSONLayer extends React.Component {
  constructor(props) {
    super(props);

    this.sourceId = uniqueId('geojson-');
    this.mapItem = { toFeatures: () => toFeatures(this.props.data) };
  }

  componentDidMount() {
    const { map, register } = this.context;

    Object.entries(this.props.images).forEach(([id, { draw, pixelRatio }]) => {
      if (!map.hasImage(id)) map.addImage(id, draw(), { pixelRatio });
    });
    map.addSource(this.sourceId, { type: 'geojson', data: this.props.data });
    this.props.layers.forEach((layer, index) => {
      map.addLayer({ ...layer, id: this.layerId(index), source: this.sourceId });
    });

    if (this.props.includeInBounds) register(this.mapItem);
  }

  componentDidUpdate(prevProps) {
    const { map } = this.context;

    if (!isEqual(prevProps.data, this.props.data)) {
      map.getSource(this.sourceId).setData(this.props.data);
    }

    this.props.layers.forEach((layer, index) => {
      const previousLayer = prevProps.layers[index] || {};

      this.updateProperties(map.setPaintProperty.bind(map, this.layerId(index)), previousLayer.paint, layer.paint);
      this.updateProperties(map.setLayoutProperty.bind(map, this.layerId(index)), previousLayer.layout, layer.layout);
    });
  }

  componentWillUnmount() {
    const { map, unregister, isRemoved } = this.context;

    unregister(this.mapItem);
    if (isRemoved()) return;

    this.props.layers.forEach((_layer, index) => map.removeLayer(this.layerId(index)));
    map.removeSource(this.sourceId);
  }

  updateProperties(setProperty, previous = {}, next = {}) {
    union(Object.keys(previous), Object.keys(next)).forEach((name) => {
      if (isEqual(previous[name], next[name])) return;

      setProperty(name, name in next ? next[name] : null);
    });
  }

  layerId(index) {
    return `${this.sourceId}-${index}`;
  }

  render() {
    return null;
  }
}

GeoJSONLayer.contextType = MapContext;

GeoJSONLayer.defaultProps = {
  images: {},
  includeInBounds: false
};

GeoJSONLayer.propTypes = {
  data: PropTypes.object.isRequired,
  layers: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      paint: PropTypes.object,
      layout: PropTypes.object
    })
  ).isRequired,
  images: PropTypes.objectOf(
    PropTypes.shape({
      draw: PropTypes.func.isRequired,
      pixelRatio: PropTypes.number
    })
  ),
  includeInBounds: PropTypes.bool
};
